<button
    class="cmps-icon-button--no-bg"
    cmpsIconButton
    [cmpsTooltipTrigger]="_i18n.__CLOSE_SEARCH | translate"
    (click)="_onToggleSearchClick()"
    *ngIf="_service.state?.searchOpen"
>
    <cmps-icon svgIcon="close"></cmps-icon>
</button>
<div class="cmps-task-list-search-filter--button-wrapper">
    <button
        class="cmps-task-list-search-filter--button"
        [class.cmps-task-list-search-filter--button-active]="
            _service.state?.filterIsDefault?.search === false
        "
        [disabled]="_service.state?.searchOpen"
        [cmpsTooltipTrigger]="_i18n._710_SEARCH | translate"
        (click)="_onToggleSearchClick()"
    >
        <cmps-icon svgIcon="magnify"></cmps-icon>
    </button>
    <div
        class="cmps-task-list-search-filter--search-input-wrapper"
        *ngIf="_service.state?.searchOpen"
    >
        <input
            [placeholder]="_i18n._710_SEARCH | translate"
            [ngModel]="_service.state?.filterOpts?.keyword ?? ''"
            (ngModelChange)="_onKeywordFilterChange($event)"
            (keydown.enter)="
                $event.preventDefault();
                _dispatchFilterKeyword(searchInputRef.value)
            "
            #searchInputRef
        />
    </div>
    <button
        class="cmps-task-list-search-filter--button cmps-task-list-search-filter--button2"
        [class.cmps-task-list-search-filter--button-active]="
            _service.state?.filterIsDefault?.filter === false
        "
        [cmpsTooltipTrigger]="_i18n._7360_FILTER | translate"
        [cmpsOverlayTrigger]="filterTpl"
    >
        <cmps-icon svgIcon="filter-outline"></cmps-icon>
    </button>
    <button
        class="cmps-task-list-search-filter--button cmps-task-list-search-filter--button2"
        [cmpsTooltipTrigger]="_i18n._9468_SORT | translate"
        [cmpsMenuTrigger]="sortMenu"
    >
        <cmps-icon svgIcon="sort-variant"></cmps-icon>
    </button>
</div>

<ng-template
    let-overlay="overlay"
    #filterTpl
>
    <!-- TODO fix uikit auto-close for mouseup (.cmps-task-list-search-filter--filter) -->
    <cmps-filter
        class="cmps-task-list-search-filter--filter"
        [overlay]="overlay"
    >
        <cmps-filter-category-header
            >{{ _i18n._127_STATUS | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <cmps-chip-list>
                <button
                    cmpsChip
                    [value]="'important'"
                    [selected]="
                        _service.state?.filterOpts?.status?.important === true
                    "
                    (click)="_onImportanceFilterClick()"
                >
                    <span>{{ _i18n._11238_IMPORTANT | translate }}</span>
                </button>
            </cmps-chip-list>
        </cmps-filter-category-body>

        <cmps-filter-category-header
            >{{ _i18n._709_DATE_RANGE | translate }}
        </cmps-filter-category-header>
        <cmps-filter-category-body>
            <div class="cmps-cdk-d-flex">
                <cmps-date-range
                    [dateRange]="_service.state?.filterOpts?.dateRange"
                    [minFromDate]="_service.state?.filterOpts?.minDate"
                    [maxFromDate]="_service.state?.filterOpts?.maxDate"
                    [minToDate]="_service.state?.filterOpts?.minDate"
                    [maxToDate]="_service.state?.filterOpts?.maxDate"
                    fromDatePlacement="bottom-right"
                    toDatePlacement="bottom-right"
                    (dateRangeChange)="_onDateRangeFilterChange($event)"
                ></cmps-date-range>
                <div class="cmps-cdk-ml-0dot5">
                    <button
                        class="cmps-icon-button--no-bg"
                        cmpsIconButton
                        [cmpsTooltipTrigger]="
                            _i18n._11237_CLEAR_DATE_FILTERS | translate
                        "
                        (click)="_onClearDateRangeClick()"
                    >
                        <cmps-icon svgIcon="close"></cmps-icon>
                    </button>
                </div>
            </div>
        </cmps-filter-category-body>
    </cmps-filter>
</ng-template>

<cmps-menu #sortMenu="cmpsMenu">
    <!-- TODO fix uikit auto-close for mouseup (.cmps-task-list-search-filter--sort-menu) -->
    <cmps-radio-group
        class="cmps-task-list-search-filter--sort-menu"
        [value]="_service.state?.orderBy"
        (change)="_onOrderByChange($event)"
    >
        <div class="cmps-cdk-font-bold cmps-cdk-pb-0dot25">
            {{ _i18n._7216_SORT_BY | translate }}
        </div>
        <div class="cmps-cdk-d-flex cmps-cdk-flex-column">
            <cmps-radio [value]="_OrderBy.DUE_DATE_ASC">
                {{ _i18n._11239_EARLIEST_DUE_DATE | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.DUE_DATE_DESC">
                {{ _i18n._11240_LATEST_DUE_DATE | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.CREATION_DATE">
                {{ _i18n._11241_CREATION_DATE | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.ALPHABETICAL_A_Z">
                {{ _i18n._11242_ALPHABETICAL__A_Z | translate }}
            </cmps-radio>
            <cmps-radio [value]="_OrderBy.ALPHABETICAL_Z_A">
                {{ _i18n._11243_ALPHABETICAL__Z_A | translate }}
            </cmps-radio>
        </div>
    </cmps-radio-group>
</cmps-menu>
